export default "__VITE_ASSET__D9k3FasA__"